import React, {useState} from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
// import necessari per gli stili e per il colore
import { withStyles } from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';
//import { yellow } from '@material-ui/core/colors';

//console.log("filters IN");
// Scelta degli stili per il bordo ed il checked
const styles = {
  root: {
    color: green[50],
    '&$checked': {
      color: green[500],
    }
  },
  checked: {},
};


function FilterSection(props) {
  //const [ViewMode, setViewMode] = useState(1); // 0=closed, 1=semi-opened, 2=opened
  const [ViewMode, setViewMode] = useState(() => {
    return props.initMode >=0 && props.initMode <= 2?  props.initMode :  1;
  }); // 0=closed, 1=semi-opened, 2=opened
  //const [State, setState] = useState({});
  const rowNum = 3;

  // estrazione delle classi degli stili dalle props
  const { classes } = props;

  const handleFilterChange = (event) => {
    //setState({ ...State, [event.target.name]: event.target.checked });
    props.changeHandler(event.target.name, {
      id: event.target.value,
      val: event.target.checked,
      param: props.param,
    });
  };

  //console.log("FilterSection");
  //console.log(props);
  //console.log(props.filters);
  //console.log(props.activeValues);
  //console.log(State);
  
  function manageMaterialFilters() {
    if ((props.filters) && (ViewMode > 0)) {
      var arr = [];
      Object.entries(props.filters).every(([k, el]) => {
//        console.log(el);
        arr.push(el.id);
//        console.log("adding: "+el[Object.keys(el)[0]]);
//        arr.push(el[Object.keys(el)[0]]);
        if ((ViewMode === 1) && (arr.length >= rowNum))
          return false;
        else
          return true;
      });

      //console.log("AAA");
      //console.log(arr);
      //console.log(props.filters);
      return arr.map((el, k) => (
        <FormControlLabel
          key={props.prefix + (k+1)}
          control={
            <Checkbox              
              //checked={State[props.prefix + "_" + (k+1)]}
              checked={props.activeValues.includes(el)? true : false}
              onChange={handleFilterChange}
//              name={props.prefix + "_" + (k+1)}
              name={props.prefix + "_" + (el)}
              value={el}   // OKKIO VERIFICARE
              // Utilizzo dei colori
              classes={{
                root: classes.root,
                checked: classes.checked,
              }}
            />
          }
          label={props.filters[el]? props.filters[el].nome : ""}         
        />
      ));
    } else 
      return null;
  }

  function manageExpand() {
    if (ViewMode === 0)
      return null; 
    if (ViewMode === 1) {
      //console.log(props.label + " " + props.filters.length);
      //if (props.filters.length > rowNum)
        return <div className="filtri-espansione" onClick={(e)=>setViewMode(2)}> Altro + </div> 
    } else
      return <div className="filtri-espansione" onClick={(e)=>setViewMode(1)}> Meno </div>
  }

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">
        {props.label}
        {ViewMode === 0 ? (
          <img
            src={"/images/arrow_filters_down.svg"}
            className="filtri-toggle"
            onClick={(e) => setViewMode(1)}
            title="espandi"
            alt="espandi"
          />
        ) : (
          <img
            src={"/images/arrow_filters_up.svg"}
            className="filtri-toggle"
            onClick={(e) => setViewMode(0)}
            title="chiudi"
            alt="chiudi"
          />
        )}
      </FormLabel>
      <FormGroup>
        {manageMaterialFilters()}
        {manageExpand()}
      </FormGroup>
    </FormControl>
  );

}

// sintassi particolare (HOC - https://pantaley.com/blog/How-to-use-withStyles-from-Material-UI-with-HOC-in-React/)
// per usare gli stili con material
export default withStyles(styles)(FilterSection);